// extracted by mini-css-extract-plugin
export default {"img":"Thumbnail_img__MRZ1O"};